// Simple global audio preference storage and subscription
const KEY = 'belivah_audio_muted';

export function getGlobalMuted(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function setGlobalMuted(muted: boolean) {
  try {
    localStorage.setItem(KEY, muted ? '1' : '0');
  } catch {}
  try {
    window.dispatchEvent(new CustomEvent('belivah:audioMuteChanged', { detail: { muted } }));
  } catch {}
}

export function onGlobalMuteChange(handler: (muted: boolean) => void) {
  const fn = (e: Event) => {
    const ce = e as CustomEvent;
    handler(!!(ce.detail?.muted));
  };
  window.addEventListener('belivah:audioMuteChanged', fn as any);
  return () => window.removeEventListener('belivah:audioMuteChanged', fn as any);
}
